import img1 from "./WhatsApp Image 2025-11-27 at 9.37.41 AM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 9.37.41 AM.jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 9.37.42 AM (1).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 9.37.42 AM (2).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 9.37.42 AM (3).jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 9.37.42 AM.jpeg";
import img7 from "./WhatsApp Image 2025-11-27 at 9.37.45 AM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
];
